// @flow
// @jsx h
declare var API_ENDPOINT: string;
// External librairies
import { h, Component } from "preact";
import { Text } from "preact-i18n";

// Style
import styles from "./style.scss";
import { withStyles } from "elc-theme";

// Components
import Container from "../container";
import BasketContainer from "../basketcontainer";
import Booking from "./booking";
import AddPromoCode from "./addpromocode";
import PromoCode from "./booking/promocode";
import AddMeetch from "./addmeetch";

import ClientInfos from "./ClientInfos";
import TermSales from "./term-sales";
import { PrimaryButton, BackButton } from "elc-button";
import FooterButton from "../footerbutton";
import {
  MasterCardIcon,
  VisaIcon,
  MaestroIcon,
  VirementBancaireIcon,
  PCIDSSIcon,
  ArrowLeftIcon
} from "elc-icons";
import Loading from "elc-loading";

import {
  toLocalePrice,
  sendCheckoutEventOrderGTM,
  sendDataLayerVariableGTM
} from "elc-commons";

import { sendOrderConfirmation } from "elc-internal-api";

import { ThemeConfig } from "elc-theme";

import Header from "../header/HeaderTitle";

type BasketProps = {
  config: WidgetConfig,
  paymentContext?: string,
  locale: string,
  currency: Currency,
  currentOrder: Order,
  onDeleteBooking: Function,
  onAddPromoCode: Function,
  goToClientForm: Function,
  goToConfirmation: Function,
  goToConfirmationPayOnArrival: Function,
  goToConfirmationCash: Function,
  goToPayment?: Function,
  addVoucherError?: Error,
  noPayment: boolean,
  paymentMethod: PaymentMethod,
  checkSession: Function,
  onAddAssurance: Function,
  dataAssurance: string,
  getAssurance: Function
};

type BasketState = {
  isTermSalesAccepted: boolean,
  loading: boolean,
  orderLocale: string,
  loadingPaiement: string,
  isAssuranceAnnulation: boolean,
  isAssuranceAnnulationValide: boolean,
};

/**
 * Basket Component showing the order and his bookings
 * with the possibility of :
 * - delete a bookings
 * - add a promo code
 * - finalize the order by going a the client details form
 */
class Basket extends Component<BasketProps, BasketState> {
  state = {
    isTermSalesAccepted: false,
    loading: false,
    orderLocale: null,
    loadingPaiement: null,
    isAssuranceAnnulation: false,
    isAssuranceAnnulationValide: false,
  };

  

  validatorDataAssurance = (data) => {
    let isValid = false;
    if (data == null || data?.idVariation) {
      return true; 
    }
    
    return isValid;
  };

  componentDidMount() {
    if(this.props.currentOrder._embedded?.userSaved?._embedded && this.props.currentOrder._embedded.userSaved._embedded.clientDataList){
        const data = this.props.currentOrder._embedded.userSaved._embedded.clientDataList
        const filtered = data.filter(
          (item) => item._embedded?.clientFormInputTypeSaved?.code === "address"
        );
      if(filtered && filtered.length > 0){
        let dataAdresse = JSON.parse(filtered[0].value);
        let data = {
            adresse: this.formatStreet(dataAdresse),
            cp: dataAdresse.postal_code,
            ville: dataAdresse.locality,
            pays: dataAdresse.code_pays,
        }
        if(this.props.dataAssurance?.idVariation ){
          data.idVariation = this.props.dataAssurance.idVariation
        }
        this.props.onAddAssurance(data);
      }
    } 
  }

    componentDidUpdate(prevProps) {
    if (
      prevProps.dataAssurance !== this.props.dataAssurance ||
      prevProps.initAssuranceMeetch !== this.props.initAssuranceMeetch
    ) {
      let isAssuranceAnnulation = this.props.initAssuranceMeetch?.variations.length > 0 ? true : false;
      this.setState({ isAssuranceAnnulation: isAssuranceAnnulation });
    
      
      if (isAssuranceAnnulation) {
        let isValid = this.validatorDataAssurance(this.props.dataAssurance);
          this.setState({ isAssuranceAnnulationValide: isValid });
        }  
    }
  }

    formatStreet(value) {
    if (!value) return "";

    const clean = v => {
      if (!v) return "";
      const str = v.toString().trim();
      return str === "_" ? "" : str;
    };

    const streetNumber = clean(value.street_number);
    const route = clean(value.route);

    return [streetNumber, route].filter(Boolean).join(" ");
  }

  handleInputChange = (inputValue: InputValue) => {
    // Validation des champs
    let isValid = this.validatorDataAssurance(inputValue);

    this.setState({ isAssuranceAnnulationValide: isValid });
    // envoie le data au aprent
    if (isValid) {
      this.props.onAddAssurance(inputValue);
    } 
  };

  goToPayment = () => {
    this.props.checkSession(this.props.currentOrder, (sessionValid) => {
      if (sessionValid) {
        this.setState({ loading: true });
        this.props.goToPayment();
      }
    });
  };

  toggleTermSalesAccepted = (isTermSalesAccepted) => {
    this.setState({ isTermSalesAccepted });
  };


  setUserClientData = (userClientData) => {
    this.setState({ userClientData });
  };
  /**
   * handle the click on finalize order button
   */
  onClickSendOrderConfirmation = () => {
    this.props.checkSession(this.props.currentOrder, (sessionValid) => {
      if (sessionValid) {
        const { currentOrder, goToConfirmation } = this.props;

        this.setState({ loadingPaiement: "OrderConfirmation" });

        // const { userClientData } = this.state;
        let orderConfirmationPayload = {};

        if (this.props.currentOrder._embedded.userSaved.email) {
          orderConfirmationPayload.email =
            this.props.currentOrder._embedded.userSaved.email;
        }
        if (this.props.currentOrder._embedded.userSaved.phone) {
          orderConfirmationPayload.mobilePhone =
            this.props.currentOrder._embedded.userSaved.phone;
        }
        // if (
        //   userClientData &&
        //   userClientData.find(
        //     data => data._embedded.clientFormInputTypeSaved.code === "mobilephone"
        //   )
        // )
        //   orderConfirmationPayload.mobilePhone = userClientData.find(
        //     data => data._embedded.clientFormInputTypeSaved.code === "mobilephone"
        //   ).value;

        sendDataLayerVariableGTM({
          "user-id": this.props.currentOrder._embedded.userSaved.id,
        });

        sendCheckoutEventOrderGTM(this.props.currentOrder, 7, false);

        if (Object.keys(orderConfirmationPayload)) {
          sendOrderConfirmation(
            currentOrder.id,
            orderConfirmationPayload,
            currentOrder ? currentOrder.locale : "fr",
            this.state.orderLocale,
          )
            .then(() => goToConfirmation())
            .catch((error) => console.error(error));
        } else {
          this.setState({ loadingPaiement: null });
          throw new Error("The order has no email or mobilePhone.");
        }
      }
    });
  };

  /**
   * handle the click pay on arrival
   */
  onClickSendOrderConfirmationPayOnArrival = () => {
    this.props.checkSession(this.props.currentOrder, (sessionValid) => {
      if (sessionValid) {
        this.setState({ loadingPaiement: "OrderConfirmationPayOnArrival" });

        let payOnArrival = true;
        // putain
        const { currentOrder, goToConfirmationPayOnArrival } = this.props;
        // const { userClientData } = this.state;

        let orderConfirmationPayload = {};

        if (this.props.currentOrder._embedded.userSaved.email) {
          orderConfirmationPayload.email =
            this.props.currentOrder._embedded.userSaved.email;
        }
        if (this.props.currentOrder._embedded.userSaved.phone) {
          orderConfirmationPayload.mobilePhone =
            this.props.currentOrder._embedded.userSaved.phone;
        }
        if (payOnArrival) {
          orderConfirmationPayload.payOnArrival = payOnArrival;
        }
        // if (
        //   userClientData &&
        //   userClientData.find(
        //     data => data._embedded.clientFormInputTypeSaved.code === "mobilephone"
        //   )
        // )
        //   orderConfirmationPayload.mobilePhone = userClientData.find(
        //     data => data._embedded.clientFormInputTypeSaved.code === "mobilephone"
        //   ).value;

        sendDataLayerVariableGTM({
          "user-id": this.props.currentOrder._embedded.userSaved.id,
        });

        sendCheckoutEventOrderGTM(this.props.currentOrder, 7, false);

        if (Object.keys(orderConfirmationPayload)) {
          sendOrderConfirmation(
            currentOrder.id,
            orderConfirmationPayload,
            currentOrder ? currentOrder.locale : "fr",
            this.state.orderLocale,
          )
            .then(() => goToConfirmationPayOnArrival())
            .catch((error) => console.error(error));
        } else {
          this.setState({ loadingPaiement: null });
          throw new Error("The order has no email or mobilePhone.");
        }
      }
    });
  };

  /**
   * handle the click cash
   */
  onClickSendOrderConfirmationCash = () => {
    this.props.checkSession(this.props.currentOrder, (sessionValid) => {
      if (sessionValid) {
        this.setState({ loadingPaiement: "OrderConfirmationCash" });
        // console.log("CA PASSE avec CASH ");
        let cash = true;
        // putain
        const { currentOrder, goToConfirmationCash } = this.props;
        // const { userClientData } = this.state;

        let orderConfirmationPayload = {};

        if (this.props.currentOrder._embedded.userSaved.email) {
          orderConfirmationPayload.email =
            this.props.currentOrder._embedded.userSaved.email;
        }
        if (this.props.currentOrder._embedded.userSaved.phone) {
          orderConfirmationPayload.mobilePhone =
            this.props.currentOrder._embedded.userSaved.phone;
        }
        if (cash) {
          orderConfirmationPayload.cash = cash;
        }
        sendDataLayerVariableGTM({
          "user-id": this.props.currentOrder._embedded.userSaved.id,
        });
        sendCheckoutEventOrderGTM(this.props.currentOrder, 7, false);

        if (Object.keys(orderConfirmationPayload)) {
          sendOrderConfirmation(
            currentOrder.id,
            orderConfirmationPayload,
            currentOrder ? currentOrder.locale : "fr",
            this.state.orderLocale,
          )
            .then(() => goToConfirmationCash())
            .catch((error) => console.error(error));
        } else {
          this.setState({ loadingPaiement: null });
          throw new Error("The order has no email or mobilePhone.");
        }
      }
    });
  };

  /**
   * handle the click confirm for a free (0€) order — nothing to pay, but the
   * distributor still needs the booking(s) confirmed to get the e-ticket (#78063)
   */
  onClickSendOrderConfirmationFree = () => {
    this.props.checkSession(this.props.currentOrder, (sessionValid) => {
      if (sessionValid) {
        this.setState({ loadingPaiement: "OrderConfirmationFree" });

        let freeConfirm = true;
        const { currentOrder, goToConfirmationPayOnArrival } = this.props;

        let orderConfirmationPayload = {};

        if (this.props.currentOrder._embedded.userSaved.email) {
          orderConfirmationPayload.email =
            this.props.currentOrder._embedded.userSaved.email;
        }
        if (this.props.currentOrder._embedded.userSaved.phone) {
          orderConfirmationPayload.mobilePhone =
            this.props.currentOrder._embedded.userSaved.phone;
        }
        if (freeConfirm) {
          orderConfirmationPayload.freeConfirm = freeConfirm;
        }
        sendDataLayerVariableGTM({
          "user-id": this.props.currentOrder._embedded.userSaved.id,
        });
        sendCheckoutEventOrderGTM(this.props.currentOrder, 7, false);

        if (Object.keys(orderConfirmationPayload)) {
          sendOrderConfirmation(
            currentOrder.id,
            orderConfirmationPayload,
            currentOrder ? currentOrder.locale : "fr",
            this.state.orderLocale,
          )
            // reutilise l'ecran de confirmation "pay on arrival" (cash=false) :
            // il affiche deja le recap generique + l'e-billet, sans montant a encaisser
            .then(() => goToConfirmationPayOnArrival())
            .catch((error) => console.error(error));
        } else {
          this.setState({ loadingPaiement: null });
          throw new Error("The order has no email or mobilePhone.");
        }
      }
    });
  };

  /**
   * Change select langue
   */
  onChangeFacture = (e) => {
    this.setState({
      orderLocale: e.target.value == "" ? null : e.target.value,
    });

    //console.log("onChangeFacture", e.target.value);
    //console.log("currentOrder", this.props.currentOrder.id);
  };

  /**
   * render
   * @param {BasketProps} the Basket component props
   * @return {ReactElement} markup
   */
  render(
    {
      config,
      paymentContext,
      locale,
      currency,
      currentOrder,
      onDeleteBooking,
      onAddPromoCode,
      goToClientForm,
      goToCatalog,
      // goToPayment,
      addVoucherError,
      getClassName,
      noPayment,
      paymentMethod,
      checkSession,
      dataAssurance,
      getAssurance,
      initAssuranceMeetch
    }: {
      config: WidgetConfig,
      locale: string,
      currency: Currency,
      currentOrder: Order,
      onDeleteBooking: Function,
      onAddPromoCode: Function,
      goToClientForm: Function,
      goToCatalog: Function,
      getClassName: Function,
      // goToPayment?: Function,
      addVoucherError?: Error,
      noPayment: boolean,
      checkSession: Function,
      dataAssurance: object | null,
      getAssurance: Function,
      initAssuranceMeetch: object | null
    },
    {
      isTermSalesAccepted,
      loading,
      loadingPaiement,
      isAssuranceAnnulation,
      isAssuranceAnnulationValide
        }: {
      isTermSalesAccepted: boolean,
      loading: boolean,
      loadingPaiement: string,
      isAssuranceAnnulation: boolean,
      isAssuranceAnnulationValide: boolean
        },
  ) {
    const lang = [
      {
        value: "fr",
        label: "Français",
      },
      {
        value: "en",
        label: "Anglais",
      },
      {
        value: "de",
        label: "Allemand",
      },
      {
        value: "it",
        label: "Italien",
      },
      {
        value: "nl",
        label: "Néerlandais",
      },
      {
        value: "es",
        label: "Espagnol",
      },
      {
        value: "ca",
        label: "Catalan",
      },
    ];

    let bookings = currentOrder ? currentOrder._embedded.bookings : [];
    let promoCode;
    let orderContainesGiftProduct = false; // pas de payOnArrival si GIFT dans le panier
    let orderContainsPromocode = false;
    let multiMerchants = false;

    let payOnArrivalAuthorized = false;
    let cashAuthorized = false;
    // panier a 0€ (produit gratuit) : pas de lien de paiement pertinent, cf #78063
    let isFreeOrder = false;
    this.listBookingsMerchants = [];
    this.listBookingsMerchantsWithLinks = [];
    if (currentOrder) {
      payOnArrivalAuthorized =
        currentOrder._embedded.company.payOnArrivalAuthorized; // config admin
      cashAuthorized = currentOrder._embedded.company.cashAuthorized; // config admin
      isFreeOrder =
        currentOrder.totalPrice === 0 || currentOrder.totalPrice === null;

      checkSession(currentOrder);
    }

    bookings.forEach((item) => {
      if (item._embedded && item._embedded.merchant) {
        this.listBookingsMerchants.push(item._embedded.merchant.id);
      }
      if (item._links && item._links.merchant) {
        // console.log("item._links.merchant.href  :", item._links.merchant.href);
        let link = item._links.merchant.href;
        let parts = link.split("/v1/companies/");
        let url = Number(parts[1]);

        this.listBookingsMerchantsWithLinks.push(url);
      }
    });
    /*    console.log(
      "this.listBookingsMerchantsWithLinks ; ",
      this.listBookingsMerchantsWithLinks
    );*/
    /*    console.log("this.listBookingsMerchants ; ", this.listBookingsMerchants);*/
    this.listBookingsMerchants = this.listBookingsMerchants.concat(
      this.listBookingsMerchantsWithLinks,
    );

    const uniqueMerchants = Array.from(new Set(this.listBookingsMerchants));
    /*    const uniqueMerchantsWithLinks = Array.from(
      new Set(this.listBookingsMerchantsWithLinks)
    );*/
    // console.log(uniqueMerchants);
    if (uniqueMerchants.length > 1) {
      multiMerchants = true;
    }
    //  console.log(multiMerchants);
    bookings.forEach((item) => {
      if (item._embedded.promoCodes && item._embedded.promoCodes.length > 0) {
        // console.log(item._embedded.promoCodes.length);
        promoCode =
          item._embedded.promoCodes[item._embedded.promoCodes.length - 1];
        orderContainsPromocode = true;
        // console.log("orderContainsPromocode?", orderContainsPromocode);
      }
    });

    bookings.forEach((item) => {
      if (item._embedded.product.type === "GIFT") {
        orderContainesGiftProduct = true;
      }
    });

    // console.log("this.props", this.props)

    return (
      <ThemeConfig.Consumer>
        {(themeConfig) => {
          return (
            <Container>
              <BasketContainer>
                {!currentOrder ? (
                  <div class={getClassName("emptyBasket")}>
                    <Text id="basket.empty">Your basket is empty.</Text>
                  </div>
                ) : (
                  currentOrder && (
                    <div class={
                          `${getClassName("columnsContainer")} ${
                            currentOrder?.status !== "USER_FILLED" ? getClassName("resumeBasket") : ""
                          }`
                        }>
                    <div class={getClassName("cellSummary")}>
                                            <div class={getClassName("basket")}>
                        <div class={getClassName("basketScrollableContent")}>
                          {currentOrder &&
                            currentOrder.status === "USER_FILLED" && (
                              <div class={getClassName("basketInfosReminder")}>
                                <strong>
                                  <Text id="basket.infosReminder">
                                    Veuillez confirmer vos informations.
                                  </Text>
                                </strong><br/>
                                <em>
                                  <Text id="basket.infosReminderSuite">
                                    Attention : Après la confirmation, vous avez
                                    15 minutes pour finaliser le paiement.
                                  </Text>
                                </em>
                              </div>
                            )}


    
                          {currentOrder &&
                            currentOrder.status !== "DRAFT" &&
                            currentOrder._embedded.userSaved && (
                              <div>
                              <ClientInfos
                                orderOrigin={currentOrder.origin}
                                orderStatus={currentOrder.status}
                                user={currentOrder._embedded.userSaved}
                                userClientData={
                                  currentOrder._embedded.userSaved._embedded &&
                                  currentOrder._embedded.userSaved._embedded
                                    .clientDataList
                                    ? currentOrder._embedded.userSaved._embedded
                                        .clientDataList
                                    : undefined
                                }
                                goToClientForm={goToClientForm}
                              />
                              </div>
                            )}
                         
                          {currentOrder.publicMetadata &&
                            currentOrder.publicMetadata.additionalPlatformFees &&
                            currentOrder.publicMetadata.additionalPlatformFees
                              .franceBillet && (
                              <footer
                                class={getClassName("additionalPlatformFees")}
                              >
                                <span
                                  class={getClassName(
                                    "additionalPlatformFeesLabel",
                                  )}
                                >
                                  <Text id="basket.additionalPlatformFees">
                                    Additional platform fees :
                                  </Text>
                                </span>
                                <span
                                  class={getClassName(
                                    "additionalPlatformFeesPrice",
                                  )}
                                  style={`color:${
                                    themeConfig && themeConfig.color1
                                      ? themeConfig.color1
                                      : ""
                                  };`}
                                >
                                  {toLocalePrice(
                                    currentOrder.publicMetadata
                                      .additionalPlatformFees.franceBillet
                                      .deliveryMode.priceTaxIncluded,
                                    locale,
                                    currency.isoCode,
                                  )}
                                </span>
                              </footer>
                            )}
                        </div>
                        {/* on masque les code promo si on arrive du SHOP */}
                              {config.type !== "KIOSK" &&
                              this.props.currentOrder.origin !== "SHOP" &&
                              this.props.currentOrder.origin !== "OPEN_API" &&
                              this.props.paymentMethod &&
                              this.props.paymentMethod.configuration.deposit ===
                                100 && (
                                <div>
                                  <AddPromoCode
                                    config={config}
                                    order={currentOrder}
                                    onAddPromoCode={onAddPromoCode}
                                    addVoucherError={addVoucherError}
                                  />
                                </div>
                              )}




                            {currentOrder &&
                              currentOrder.status !== "DRAFT" &&
                              currentOrder._embedded.userSaved &&
                              currentOrder.origin !== "OPEN_API" &&
                              (!paymentContext || paymentContext !== "mobile") &&  (
                                <div>
                                    {/* <pre>{JSON.stringify(paymentContext, null, 2)}</pre>
                                    <pre>{JSON.stringify(config, null, 2)}</pre> */}
                                    <AddMeetch
                                      isAssuranceAnnulation={isAssuranceAnnulation}
                                      handleInputChange={this.handleInputChange}
                                      locale={locale}
                                      currency={currency}
                                      dataAssurance={dataAssurance}
                                      currentOrder={currentOrder}
                                      getAssurance={getAssurance}
                                      initAssuranceMeetch={initAssuranceMeetch}
                                    ></AddMeetch>
                                </div>
                              )}

                              {currentOrder.status === "USER_FILLED" &&
                              (!paymentContext || paymentContext !== "mobile") && (
                                <TermSales
                                  order={currentOrder}
                                  isTermSalesAccepted={isTermSalesAccepted}
                                  toggleTermSalesAccepted={
                                    this.toggleTermSalesAccepted
                                  }
                                />
                              )}                      

                      </div>

                      
              <FooterButton config={config}>
                {currentOrder &&
                currentOrder.status === "USER_FILLED" &&
                paymentContext &&
                paymentContext === "mobile" ? (
                  <div>
                    <div class={getClassName("selectWrapper")}>
                      <select
                        name="factureLang"
                        onChange={this.onChangeFacture}
                        value={
                          this.state.orderLocale === null
                            ? ""
                            : this.state.orderLocale
                        }
                        class={getClassName("select")}
                      >
                        <option value="">
                          <Text id="basket.choixLangueEdition">
                            Choisissez la langue de l'édition
                          </Text>
                        </option>
                        {lang.map((option, key) => (
                          <option key={key} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {currentOrder &&
                currentOrder.status === "USER_FILLED" &&
                paymentContext &&
                paymentContext === "mobile" &&
                payOnArrivalAuthorized === true &&
                orderContainesGiftProduct === false &&
                multiMerchants === false &&
                !isFreeOrder ? (
                  <PrimaryButton
                    handleClick={this.onClickSendOrderConfirmationPayOnArrival}
                    disabled={
                      this.state.orderLocale === null ||
                      loadingPaiement !== null
                    }
                  >
                    {loadingPaiement === "OrderConfirmationPayOnArrival" ? (
                      <Loading color="#ff4156" />
                    ) : (
                      <Text id="basket.payOnArrival">Payer sur place</Text>
                    )}
                  </PrimaryButton>
                ) : (
                  ""
                )}
                {currentOrder &&
                currentOrder.status === "USER_FILLED" &&
                paymentContext &&
                paymentContext === "mobile" &&
                cashAuthorized === true &&
                orderContainesGiftProduct === false &&
                orderContainsPromocode === false &&
                multiMerchants === false &&
                !isFreeOrder ? (
                  <PrimaryButton
                    handleClick={this.onClickSendOrderConfirmationCash}
                    disabled={
                      this.state.orderLocale === null ||
                      loadingPaiement !== null
                    }
                  >
                    {loadingPaiement === "OrderConfirmationCash" ? (
                      <Loading color="#ff4156" />
                    ) : (
                      <Text id="basket.cash">J'ai encaissé</Text>
                    )}
                  </PrimaryButton>
                ) : (
                  ""
                )}

                {noPayment ? (
                  <div class={styles.errorMessage}>
                    <Text id="basket.noPayment">
                      Paiement temporairement indisponible
                    </Text>
                  </div>
                ) : (
                  ""
                )}
                {currentOrder && currentOrder.status === "DRAFT" ? (
                  <PrimaryButton
                    handleClick={goToClientForm}
                    disabled={
                      (isAssuranceAnnulation && !isAssuranceAnnulationValide) ||
                      loading
                    }
                  >
                    <Text id="basket.finalizeOrder">Finalize my order</Text>
                  </PrimaryButton>
                ) : currentOrder &&
                  currentOrder.status === "USER_FILLED" &&
                  paymentContext &&
                  paymentContext === "mobile" &&
                  isFreeOrder ? (
                  <PrimaryButton
                    handleClick={this.onClickSendOrderConfirmationFree}
                    disabled={
                      this.state.orderLocale === null ||
                      loadingPaiement !== null
                    }
                  >
                    {loadingPaiement === "OrderConfirmationFree" ? (
                      <Loading color="#ff4156" />
                    ) : (
                      <Text id="basket.confirmFreeOrder">Confirmer</Text>
                    )}
                  </PrimaryButton>
                ) : currentOrder &&
                  currentOrder.status === "USER_FILLED" &&
                  paymentContext &&
                  paymentContext === "mobile" ? (
                  <PrimaryButton
                    handleClick={this.onClickSendOrderConfirmation}
                    disabled={
                      this.state.orderLocale === null ||
                      loadingPaiement !== null
                    }
                  >
                    {loadingPaiement === "OrderConfirmation" ? (
                      <Loading color="#ff4156" />
                    ) : (
                      <Text id="basket.payWithMobile">Pay with my mobile</Text>
                    )}
                  </PrimaryButton>
                ) : currentOrder &&
                  currentOrder.status === "USER_FILLED" &&
                  !noPayment ? (
                  <PrimaryButton
                    handleClick={this.goToPayment}
                    disabled={
                      !isTermSalesAccepted ||
                      (isAssuranceAnnulation && !isAssuranceAnnulationValide) ||
                      loading
                    }
                  >
                    {loading ? (
                      <Loading color="#fff" />
                    ) : currentOrder.totalPrice !== 0 &&
                      currentOrder.totalPrice !== null ? (
                      <Text id="basket.payOrder">Pay my order</Text>
                    ) : (
                      <Text id="basket.confirmOrder">Confirm my order</Text>
                    )}
                  </PrimaryButton>
                ) : (
                  ""
                )}
                {goToCatalog && (
                  <BackButton
                    handleClick={goToCatalog}
                    e={getClassName("previousButton")}
                  >
                    {config.type !== "kiosk" && (
                      <ArrowLeftIcon
                        color={
                          themeConfig && themeConfig.color1
                            ? themeConfig.color1
                            : styles.green
                        }
                      />
                    )}
                    <Text id="basket.continueShopping">Continue shopping</Text>
                  </BackButton>
                )}
                <div class={getClassName("ccImgContainer")}>
                  <MasterCardIcon />
                  <MaestroIcon />
                  <VisaIcon />
                  <VirementBancaireIcon />
                  <PCIDSSIcon />
                </div>
              </FooterButton>

                    </div>


                      <div class={getClassName("cellBasket")}>
                            <div class={getClassName("basketCard")}>
                              {config.type !== "SHOP" && <Header />}
                              <div class={getClassName("basketCardContent")}>

                            {currentOrder._embedded.bookings &&
                              currentOrder._embedded.bookings.map((booking) => (
                                    <Booking
                                    key={booking.id}
                                    order={currentOrder}
                                    booking={booking}
                                    locale={locale}
                                    currency={currency}
                                    onDeleteBooking={onDeleteBooking}
                                  />
                              ))}
                            <div class={getClassName("footerPaymentContainer")}>
                              <footer class={getClassName("footerPaiement")}>
                                <h3 class={getClassName("totalTitle")}>
                                  <Text id="basket.total">Total :</Text>
                                </h3>
                                <div
                                  class={getClassName("price")}
                                  style={`color:${
                                    themeConfig && themeConfig.color1
                                      ? themeConfig.color1
                                      : ""
                                  };`}
                                >
                                  <h3>
                                    {toLocalePrice(
                                      currentOrder.totalPrice,
                                      locale,
                                      currency.isoCode,
                                    )}
                                  </h3>
                                </div>
                              </footer>
                            </div>
                              </div>

                            </div>
                            

                      </div>
                    </div>
                  )
                )}
              </BasketContainer>



            </Container>
          );
        }}
      </ThemeConfig.Consumer>
    );
  }
}

export default withStyles(Basket, styles);
